module.exports = __webpack_public_path__ + "img/handheld_example@3x.21316904.png";